import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-control-efectivo',
  templateUrl: './control-efectivo.component.html',
  styleUrls: ['./control-efectivo.component.scss']
})
export class ControlEfectivoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
